module.exports = __webpack_public_path__ + "static/media/marseille-1.537c8ff2.jpg";